import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SliderProComponent } from './slider-pro.component';

@NgModule({
    imports: [CommonModule],
    exports: [SliderProComponent],
    declarations: [SliderProComponent],
    providers: [],
})
export class SliderProModule { }
